module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-credits-rating-5a51782833216aba3350f6317add8250.png";